'use strict';

/**
 *
 * @name: permissions
 *
 */

function PermissionsFactory($rootScope, $location, $q) {

  'ngInject';

  function resolveUser() {

    var deferred = $q.defer();

    if ($rootScope.profile === false || typeof $rootScope.profile === 'object') {

      deferred.resolve('done');
    } else {

      $rootScope.$watch('profile', function(newVal) {

        if (newVal === false || typeof newVal === 'object') {
          deferred.resolve('done');
        }
      });
    }
    return deferred.promise;
  }

  function nightWatch() {
    $rootScope.$on('$stateChangeStart', function(event, toState) {
      resolveUser().then(function() {

        /*jslint laxbreak: true */
        if (toState.data &&
          toState.data.access &&
          toState.data.access !== 'anon' &&
          (!$rootScope.profile || $rootScope.profile.roles.indexOf(toState.data.access) === -1)) {

          $location.path('/');
        }
      });

    });
  }

  return {
    nightWatch: nightWatch
  };
}

export default PermissionsFactory;



// WEBPACK FOOTER //
// ./app/pages/user/permissions.factory.js